import React from "react";
import Tag from "./logotager.png";
import { useNavigate } from "react-router-dom";


const VerticalNavnew = () => {
  // Navigation items and their corresponding URLs
  // const navItems = [
  //   { name: "bank1to2", url: "/bank1to2" },
  //   { name: "bank2to3", url: "/bank2to3" },
  //   { name: "bank4to5", url: "/bank4to5" },
  //   { name: "bank15to24", url: "/bank15to24" },
  //   { name: "bank15to25", url: "/bank15to25" },
  //   { name: "atm-withdrawal", url: "/atm-withdrawal" },
  //   { name: "Dashboard", url: "/dashboard" },
  // ];

  // Additional buttons with new text
  const additionalButtons = [
    { name: "NEW LOOP TAG", url: "/bank1to2reference" },
    { name: "WITHDRAW  /  SPEND ", url: "/atm-withdrawalreference" },
    { name: "REFERENCE LOOP TAG ", url: "/bank2to3reference" },
    { name: "FRAUD MODUS OPERANDI 1", url: "/bank4to5reference" },
    { name: "FRAUD MODUS OPERANDI 2", url: "/bank15to24reference" },
    { name: "RELEASE LOOP TAG ", url: "/bank15to25reference" },
    { name: "EARLY WARNING SIGNAL (EWS)", url: "/bank26to27reference" },
    { name: "DASHBOARD", url: "/dashboardreference" },
    //{ name: "Reference Tag", url: "/bank4to5reference" },
  ];

  // Function to open the URL in a new tab
  const openInNewTab = (url) => {
    const baseUrl = "https://tagprotect.in"; // Adjust the base URL as needed
    //const baseUrl = "http://localhost:3000"; // Adjust the base URL as needed
    window.open(`${baseUrl}${url}`, "_blank", "noopener,noreferrer");
  };
  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleLogout = () => {
    // Clear login status from localStorage
    localStorage.removeItem("isLoggedIn");

    // Notify other tabs about logout
    localStorage.setItem("logout-event", Date.now());

    // Redirect to LoginPage (forces reload in all tabs)
    window.location.href = "/";
  };


  return (
    <div style={styles.container}>
      <div style={styles.imageSidebar}>
        <img
          src={Tag} // Replace with your image URL
          alt="Sidebar"
          style={styles.image}
        />
      </div>

      {/* Buttons in the Center */}
      <div style={styles.centerContent}>
        {additionalButtons.map((item) => (
          <button
            key={item.name}
            style={styles.centerButton}
            onClick={() => openInNewTab(item.url)}>
            {item.name}
          </button>
        ))}
      </div>
      <button className="logout2-btn" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

// Inline styles for the component
const styles = {
  container: {
    display: "flex",
    height: "100vh",
    position: "fixed",
    //backgroundColor: "#f5f5f5",
    marginTop: "5%",
  },
  sidebar: {
    width: "200px",
    //backgroundColor: "#333",
    padding: "10px",
  },
  imageSidebar: {
    width: "45%", // Fixed width for the sidebar
    backgroundColor: "#FFF",
    display: "flex",
    justifyContent: "center", // Center the image horizontally
    alignItems: "center", // Center the image vertically
    marginTop: "-17%",
  },
  image: {
    width: "45%", // Adjust width relative to sidebar
    height: "auto", // Maintain aspect ratio
    objectFit: "contain", // Ensure the image fits without being cropped
  },
  nav: {
    display: "flex",
    flexDirection: "column",
  },
  navItem: {
    padding: "10px 15px",
    color: "#fff",
    backgroundColor: "transparent",
    border: "none",
    textAlign: "left",
    cursor: "pointer",
    marginBottom: "5px",
    fontSize: "16px",
  },
  centerContent: {
    flex: 1,
    marginTop: "-10%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center", // Center the image horizontally
    alignItems: "center", // Center the image vertically
    // alignItems: "flex-start", // Aligns buttons to the left
    padding: "20px", // Adds padding for spacing
  },
  centerButton: {
    minWidth: "315px", // Minimum width for buttons
    height: "50px", // Fixed height for consistency
    padding: "0 15px", // Horizontal padding for text spacing
    color: "#fff",
    backgroundColor: "#007BFF",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginBottom: "10px", // Adds space between buttons
    fontSize: "18px",
    fontWeight: "bold",
    letterSpacing: "0.5px", // Adds letter spacing
    fontFamily: "sans-serif", // Sets the font family
    textAlign: "center",
    lineHeight: "50px", // Centers text vertically
    transition: "background-color 0.3s",
    whiteSpace: "nowrap", // Prevents text from wrapping
  },
};

export default VerticalNavnew;
